import type { Game } from './game';

/** A single-player chase should wait until the player explicitly resumes after leaving. */
export function bindGameFocus(g: Game, win: Window = window, doc: Document = document): () => void {
  const blur = () => {
    g.input.reset();
    if (g.phase === 'play' && g.overlay === 'none') { g.overlay = 'pause'; g.menuIndex = 0; }
    g.audio.setBackground(true);
  };
  const focus = () => g.audio.setBackground(doc.hidden);
  const visibility = () => doc.hidden ? blur() : focus();
  win.addEventListener('blur', blur);
  win.addEventListener('focus', focus);
  doc.addEventListener('visibilitychange', visibility);
  if (doc.hidden) blur();
  return () => {
    win.removeEventListener('blur', blur);
    win.removeEventListener('focus', focus);
    doc.removeEventListener('visibilitychange', visibility);
  };
}
